<template>
  <div id="body" v-title data-title="立即提现">
    <div>
      <wv-group>
        <wvi-input
          label="提现金额"
          placeholder="请输入提现金额"
          v-model="formset.Amount"
          :ref="101"
          :validate-info="{errormsg:'提现金额不合法'}"
          required
          pattern="^(([1-9][0-9]*)|([0]))(\.\d{1,2})?$"
          @input="handleInput()"
        ></wvi-input>
        <wv-cell ref="ftax" title="应缴个税" :value="formset.Tax"></wv-cell>
        <wv-cell ref="money" title="到账金额" :value="formset.Amount-formset.Tax">11</wv-cell>
      </wv-group>
      <wv-group>
        <!-- <wvi-input label="真实姓名" v-model="formset.RealName"></wvi-input> -->
        <wv-cell title="真实姓名" :value="formset.RealName"></wv-cell>
        <wv-cell title="提现账户" :value="formset.WechatName"></wv-cell>
        <wv-cell title="可提现金额" :value="formset.ExtractBalance|currency('￥','2')"></wv-cell>
        <wv-cell title="本月提现金额" :value="formset.MonthBalance|currency('￥','2')"></wv-cell>
        <wv-cell title="本月代缴个税" :value="formset.MonthTax|currency('￥','2')"></wv-cell>
      </wv-group>
    </div>
    <div class="weui-cell">
      <wv-button type="primary" @click="btnSave()">确定</wv-button>
    </div>
      <div class="container">
        <div class="tx-tips">
          <p>重要提示：</p>
          <ul>
<li>1、为遵守国家税务部门监管要求，中国国旅江苏公司将为您在本平台获取的佣金代为申报个人所得税；</li>
<li>2、原则上每月提现佣金建议不超过800元，超出部分将代为扣税后按照税后金额提现，建议超过800的采取分月提现；</li>
<li>3、最终是否扣税取决于您全年合计收入；</li>
<li>4、个税税率详细计算方法以国家税务部门公布为准。</li>
            
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import { Dialog } from "we-vue";
import thumb from "../../assets/logo.png";

export default {
  name: "immediatewithdrawal",
  data: function() {
    return {
      formset: {}
    };
  },
  created: function() {
    this.initwithdrawal();
  },
  mounted: function() {
    var url = window.location.href;
    var code = this.GetRequest(url)["code"];
    if (code != undefined) {
      console.info(code);
      this.BindWechat(code);
    }
  },
  methods: {
    //绑定微信
    BindWechat: function(code) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/bindwechat", {
          params: {
            code: code
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            //绑定成功
            window.location.href =
              this.GLOBAL.WEB_URL + "/#/page/immediatewithdrawal";
          } else {
            Toast.fail(rep.Message);
          }
        });
    },

    //初始化提现信息
    initwithdrawal: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/sysaccount/initwithdrawal", {
          params: {}
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
              this.formset.Amount=0;
              this.formset.Tax=0;
            } else {
              var url = window.location.href;
              var code = this.GetRequest(url)["code"];
              if (rep.Message == "提现需授权微信公众号"&&code==undefined) {
                window.location.href =
                  "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+this.GLOBAL.appid+"&redirect_uri="+this.GLOBAL.redirect_uri+"%23%2Fpage%2Fimmediatewithdrawal&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
              } else if(rep.Message != "提现需授权微信公众号"){
                Toast.fail(rep.Message);
              }
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },

    //验证
    validatesave: function() {
      var com = this.$refs;
      var flag = true;
      for (var c in com) {
        if(c=="101"){
        if (this.$refs[c].length != undefined) {
          this.$refs[c][0].validate();
          flag = this.$refs[c][0].valid;
        } else {
          this.$refs[c].validate();
          flag = this.$refs[c].valid;
        }
        if (!flag) return flag;
        }
      }
      return flag;
    },

    //提现数值改变导致的税收改变
    handleInput:function(){
      var data = this.formset;
          this.$http
            .post(
              this.GLOBAL.BASE_URL + "api/sysaccount/GetTaxRevenue",
              data,
              {
                emulateJSON: true
              }
            )
            .then(
              function(d) {
                var rep = JSON.parse(d.bodyText);
                if (rep.Success) {                     
                  this.$refs.ftax.value=rep.Data;
                  this.$refs.money.value=this.formset.Amount-this.formset.Tax;
                } else {
                  Toast.fail(rep.Message);
                }
              },
              function(d) {
                console.log(d);
              }
            );
    },

    //提现
    btnSave: function(orderType) {
      if (
        parseInt(this.formset.Amount) > parseInt(this.formset.ExtractBalance)
      ) {
        Toast.fail("提现金额不能大于可提现金额");
        return;
      }
      if (!this.validatesave()) {
        Toast.fail("验证没通过");
      } else {
        Dialog.confirm({
          title: "确认信息",
          message: "是否确认提现",
          skin: "ios",
          showCancelButton: true
        }).then(() => {
          var data = this.formset;
          this.$http
            .post(
              this.GLOBAL.BASE_URL + "api/sysaccount/withdrawalToChange",
              data,
              {
                emulateJSON: true
              }
            )
            .then(
              function(d) {
                var rep = JSON.parse(d.bodyText);
                if (rep.Success) {
                  Toast.success("提交成功");
                  this.$router.push("/app/home");
                } else {
                  Toast.fail(rep.Message);
                }
              },
              function(d) {
                console.log(d);
              }
            );
        });
      }
    }
  }
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/mypurse/immediatewithdrawal.vue